import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronUp } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const [enabled, setEnabled] = useState(true);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    axios.get(`${API}/public/ui-toggles`)
      .then((r) => setEnabled(r.data?.back_to_top_enabled !== false))
      .catch(() => {});
  }, []);

  if (!enabled || !visible) return null;

  // Mobile: sits above the 64px bottom nav (bottom-24). Desktop: normal
  // corner offset (bottom-6). On the homepage the mobile bump is even
  // higher (bottom-32) to clear both the mobile nav AND the chatbot FAB.
  const bottomClass = isHome ? 'bottom-32 md:bottom-6' : 'bottom-24 md:bottom-6';

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed z-50 p-3 rounded-full bg-[#0F2C3E] text-white shadow-lg hover:bg-[#0F2C3E]/90 transition-all duration-300 hover:scale-105 active:scale-95 right-6 ${bottomClass}`}
      data-testid="back-to-top-btn"
      aria-label="Back to top"
    >
      <ChevronUp className="h-5 w-5" />
    </button>
  );
};

export default BackToTop;
